import { useTranslation } from 'react-i18next';

import WarningModal from '../WarningModal';

type CloseWarningModalProps = {
   opened: boolean;
   onClose: () => void;
   onConfirm: () => void;
};

const CloseWarningModal = ({ opened, onClose, onConfirm }: CloseWarningModalProps) => {
   const { t } = useTranslation();

   return (
      <WarningModal
         heading={t('closeWarningModal.heading')}
         description={t('closeWarningModal.description')}
         cancelBtnText={t('closeWarningModal.cancelBtnText')}
         confirmBtnText={t('closeWarningModal.confirmBtnText')}
         opened={opened}
         size="600"
         onClose={onClose}
         onConfirm={onConfirm}
      />
   );
};

export default CloseWarningModal;
